import { PricingOverrideReport } from "./overrideTypes";
import { PricingKeyRow, PricingVersionEditFormValues } from "./types";

/**
 * Prazan obrazac cjenika. Nijedan iznos ovdje nije upisan — sve dolazi iz baze;
 * ovo je samo oblik koji obrazac očekuje prije nego se napuni.
 */
export const initialPricingVersionEditForm: PricingVersionEditFormValues = {
  validFrom: null,
  note: null,
  values: {},
  combinations: [],
  priceTiers: [],
};

/**
 * Novi razred, dodaje se na kraj i otvoren je prema beskonačnosti.
 *
 * Stopa kreće od pune cijene, ne od prazne vrijednosti: `NumberField` prazan decimalni broj
 * ispisuje kao 0,00, pa bi razred izgledao kao besplatan, a validacija bi tražila vrijednost
 * koja je naizgled već upisana.
 */
export const initialPriceTier = {
  fromVehicle: null,
  toVehicle: null,
  ratePercent: 100,
};

/** Prazan izvještaj o odstupanjima, prije nego stigne s backenda. */
export const initialOverrideReport: PricingOverrideReport = {
  overrides: [],
  measuredMonthlyEffect: 0,
  unmeasuredKeys: [],
};

/**
 * Mjerene stavke iz šifrarnika ključeva.
 *
 * Pravilo stoji na jednom mjestu jer ga traže i korak pretplate i kalkulator: kad bi svaki
 * imao svoj filtar, jedan bi zaboravio ugašene ključeve i računao po cijeni koja više ne vrijedi.
 */
export const selectMeteredKeys = (keys: PricingKeyRow[]): PricingKeyRow[] =>
  keys.filter((key) => key.costKeyCode !== null && key.isActive);

/** Marža ispod koje unos traži odobrenje. Prag, ne iznos. */
export const MINIMUM_MARGIN_WITHOUT_APPROVAL = 0.3;

/** Format postotka marže za prikaz. */
export const formatMargin = (margin: number): string =>
  `${(margin * 100).toFixed(1).replace(".", ",")} %`;

/**
 * Cijena po jedinici. Namjerno do 4 decimale — `nabava.ocr` je 0,004, pa bi
 * zaokruživanje na 2 decimale pokazalo 0,00 i sakrilo maržu.
 */
export const formatUnitPrice = new Intl.NumberFormat("hr-HR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});
